import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { brand, parentPoints } from '../data/content';
export function ForParents() {
  return <section id="for-parents" className="bg-pearl-100 py-14 dark:bg-slate-950 sm:py-16" data-id="element-108" data-mp="24ecbe89mi39p">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-109" data-mp="1zl9epr9judpa">
        <div className="rounded-[2rem] border border-pearl-300 bg-white p-6 dark:border-slate-800 dark:bg-slate-900 sm:rounded-[2.5rem] sm:p-10" data-id="element-110" data-mp="1unzk7x7azbul">
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between" data-id="element-111" data-mp="1pq7pkvf9xbmp">
            <div className="max-w-lg" data-id="element-112" data-mp="1ko07rp7rj1cg">
              <span className="inline-flex items-center gap-2 rounded-full bg-slate-900 px-3.5 py-1.5 text-xs font-semibold uppercase tracking-[0.12em] text-pearl-50 dark:bg-butter-300 dark:text-slate-900" data-id="element-113" data-mp="1gnyg88vqroaw">
                <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-114" data-mp="3b1pmqzirxs24" />
                FOR HIGH SCHOOL PARENTS
              </span>
              <h2 className="mt-4 font-display text-3xl font-semibold tracking-tight text-slate-900 dark:text-pearl-50" data-id="element-115" data-mp="363xta12hdxvt">
                The part you were going to ask about
              </h2>
            </div>

            <p className="text-sm text-slate-500 dark:text-slate-400" data-id="element-116" data-mp="vpsr76cf1sic">
              Questions before booking? Email{' '}
              <a href={`mailto:${brand.email}`} className="font-semibold text-slate-800 underline underline-offset-4 dark:text-butter-300" data-id="element-117" data-mp="hqjdcdbonahj">
                {brand.email}
              </a>
              .
            </p>
          </div>

          <dl className="mt-8 grid gap-6 border-t border-slate-200 pt-8 dark:border-slate-800 sm:grid-cols-2 sm:gap-10" data-id="element-118" data-mp="1ef8svwzu7r0c">
            {parentPoints.slice(0, 2).map(point => <div key={point.title} className="border-l-2 border-butter-300 pl-5 dark:border-butter-500/60" data-id="element-119" data-mp="10l849w2lnkdp">
                <dt className="font-display text-lg font-semibold text-slate-900 dark:text-pearl-50" data-id="element-120" data-mp="15k2litkx50vp">
                  {point.title}
                </dt>
                <dd className="mt-2 leading-relaxed text-slate-600 dark:text-slate-300" data-id="element-121" data-mp="1y3hx55ennng7">
                  {point.description}
                </dd>
              </div>)}
          </dl>
        </div>
      </div>
    </section>;
}